import axios from "axios";
import { getCurrentLanguage } from "../i18n";
import { getAccessToken, setAccessToken } from "./accessToken";
import { isCookieAuthMode } from "./authMode";

const AUTH_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api/";

let refreshPromise = null;

export function ensureAuthSession({ forceRefresh = false } = {}) {
    const currentToken = getAccessToken();
    if (!forceRefresh && currentToken) {
        return Promise.resolve(currentToken);
    }

    if (!refreshPromise) {
        refreshPromise = axios
            .post(
                `${AUTH_BASE_URL}users/refresh`,
                {},
                {
                    timeout: 15000,
                    withCredentials: true,
                    headers: {
                        "X-Client-Language": getCurrentLanguage(),
                    },
                }
            )
            .then((res) => {
                const token = res?.data?.data?.access_token;
                if (!token && !isCookieAuthMode()) {
                    throw new Error("Missing access token in refresh response");
                }
                setAccessToken(token);
                return token || null;
            })
            .finally(() => {
                refreshPromise = null;
            });
    }

    return refreshPromise;
}
